export enum ChoiceQuizType {
  SingleChoice = 'singleChoice',
  MultipleChoice = 'multipleChoice'
}
